module.exports = __webpack_public_path__ + "img/编组5.f1d3fba0.png";